import * as React from "react";
import { ZoomContainer } from "./zoom-container";
import { BackgroundGrid } from "./svg-misc";

export function ApiMap({ children }: { children: React.ReactNode }) {
  return (
    <ZoomContainer>
      {/* <AxesAndBounds /> */}
      <g id="content">
        <BackgroundGrid />
        {children}
      </g>
    </ZoomContainer>
  );
}
